// import { useData } from 'context/DataContext'
// import React, { useMemo, useState } from 'react'
// import Modal from 'utils/Modal'
// import logo from 'assets/images/logo.png'
// import Alert from 'utils/Alert'
// import { db, ref, update } from 'config/Firebase'
// import { exportProjectsToJson } from 'utils/exportProjectsToJson'

// const platforms = ['Fiverr', 'Upwork', 'Others']

// let valuesObject = {
//   name: '',
//   link: '',
//   order_number: '',
//   beckend: '',
//   portfolio: '',
//   platform: '',
//   description: '',
//   status: '',
//   footer_branding: '',
//   url_branding: '',
//   notes: '',
// }

// const Platform = () => {
//   const [filterState, setFilterState] = useState([])
//   const [portfolioCheck, setPortfolioCheck] = useState('')
//   const [searchValue, setSearchValue] = useState('')
//   const [noFooterBranding, setNoFooterBranding] = useState(false)
//   const [noUrlBranding, setNoUrlBranding] = useState(false)
//   const [exporting, setExporting] = useState(false)

//   // edit modal state
//   const [modal, setModal] = useState(false)
//   const [inputValues, setInputValues] = useState(valuesObject)
//   const [projectCategorySelected, setProjectCategorySelected] = useState([])
//   const [toggleCategoryList, settoggleCategoryList] = useState(false)
//   const [projectId, setProjectId] = useState('')
//   const [submitting, setSubmitting] = useState(false)
//   const [alert, setAlert] = useState({ open: false, msg: '', type: '' })

//   const { data, categoriesData } = useData()

//   const handleChangeFilter = (e) => {
//     if (e.target.checked) {
//       setFilterState([...filterState, e.target.value])
//     } else {
//       let filter = filterState.filter((val) => val !== e.target.value)
//       setFilterState(filter)
//     }
//   }

//   const handleRadio = (e) => {
//     setPortfolioCheck(e.target.value)
//   }
//   // main search box - matches against project name AND order number,
//   // so there's a single search field instead of two separate ones
//   const handleSearch = (e) => {
//     setSearchValue(e.target.value)
//   }

//   // Single source of truth for filtering: combines every active filter
//   // (search, platform, portfolio, footer branding, url branding) with AND
//   // logic, and uses optional chaining throughout so a record missing any
//   // field never throws and silently breaks the list.
//   const filterProjectData = useMemo(() => {
//     const list = Array.isArray(data) ? data : []
//     const search = searchValue.trim().toLowerCase()

//     return list.filter((val) => {
//       const iv = val?.inputValues || {}

//       if (search) {
//         const nameMatch = (iv.name || '').toLowerCase().includes(search)
//         const orderNumberMatch = (iv.order_number || '')
//           .toLowerCase()
//           .includes(search)
//         if (!nameMatch && !orderNumberMatch) return false
//       }

//       if (filterState.length > 0) {
//         const platformMatch = filterState.some(
//           (el) => (iv.platform || '').toLowerCase() === el.toLowerCase(),
//         )
//         if (!platformMatch) return false
//       }

//       if (portfolioCheck && iv.portfolio !== portfolioCheck) {
//         return false
//       }

//       if (noFooterBranding && iv.footer_branding !== 'No') {
//         return false
//       }

//       if (noUrlBranding && iv.url_branding !== 'No') {
//         return false
//       }

//       return true
//     })
//   }, [
//     data,
//     filterState,
//     portfolioCheck,
//     searchValue,
//     noFooterBranding,
//     noUrlBranding,
//   ])

//   // download every project as a JSON file, straight from the data already
//   // loaded in context - no extra fetch, no external service.
//   const handleDownloadJson = () => {
//     setExporting(true)
//     try {
//       const filename = exportProjectsToJson(data, {
//         filenamePrefix: 'projects',
//       })
//       setAlert({
//         open: true,
//         msg: `Downloaded ${filename}`,
//         type: 'success',
//       })
//     } catch (err) {
//       console.log(err)
//       setAlert({
//         open: true,
//         msg: 'Something went wrong generating the JSON file!',
//         type: 'error',
//       })
//     } finally {
//       setExporting(false)
//     }
//   }

//   // wraps the portion of `text` that matches the current search box value
//   // in a <mark>, so a hit on name or order number is visible at a glance
//   const highlightMatch = (text, query) => {
//     const str = text == null ? '' : String(text)
//     if (!query) return str
//     const lowerStr = str.toLowerCase()
//     const lowerQuery = query.toLowerCase()
//     let start = 0
//     let idx = lowerStr.indexOf(lowerQuery, start)
//     if (idx === -1) return str
//     const parts = []
//     while (idx !== -1) {
//       parts.push(str.slice(start, idx))
//       parts.push(
//         <mark key={idx} className="search-highlight">
//           {str.slice(idx, idx + query.length)}
//         </mark>,
//       )
//       start = idx + query.length
//       idx = lowerStr.indexOf(lowerQuery, start)
//     }
//     parts.push(str.slice(start))
//     return parts
//   }

//   const handleChange = (e) => {
//     setInputValues({ ...inputValues, [e.target.name]: e.target.value })
//   }

//   const handleSetCategory = (e) => {
//     if (e.target.checked) {
//       setProjectCategorySelected([...projectCategorySelected, e.target.value])
//     } else {
//       let filter = projectCategorySelected.filter(
//         (val) => val !== e.target.value,
//       )
//       setProjectCategorySelected(filter)
//     }
//   }

//   const handleUnselectCategory = (e) => {
//     let filterdSelectedCategory = projectCategorySelected.filter(
//       (val) => val !== e,
//     )
//     setProjectCategorySelected(filterdSelectedCategory)
//   }

//   const handleShowCategoryList = () => {
//     settoggleCategoryList(!toggleCategoryList)
//   }

//   // edit an existing row
//   const handleEdit = (event) => {
//     setModal(true)
//     setProjectCategorySelected(event.categories)
//     setInputValues(event.inputValues)
//     setProjectId(event.id)
//   }

//   const handleUpdateData = (e) => {
//     e.preventDefault()
//     setSubmitting(true)
//     if (projectCategorySelected.length > 0) {
//       update(ref(db, `projects/${projectId}`), {
//         inputValues,
//         categories: projectCategorySelected,
//       })
//         .then(() => {
//           setModal(false)
//           setSubmitting(false)
//           setInputValues(valuesObject)
//           setProjectId('')
//           setProjectCategorySelected([])
//           setAlert({
//             open: true,
//             msg: 'Data Updated successfully.',
//             type: 'success',
//           })
//         })
//         .catch((err) => {
//           console.log(err)
//           setModal(false)
//           setSubmitting(false)
//           setAlert({
//             open: true,
//             msg: 'Something went wrong!',
//             type: 'error',
//           })
//         })
//     } else {
//       setSubmitting(false)
//       setAlert({
//         open: true,
//         msg: 'Please select atleast one category',
//         type: 'error',
//       })
//     }
//   }

//   return (
//     <div>
//       {/*================ Edit Modal ===================*/}
//       <Modal open={modal}>
//         <div className="cs_modal_wrapper">
//           <div
//             className="cs_modal_backdrop"
//             onClick={() => setModal(false)}
//           ></div>
//           <div className="cs_modal">
//             <header className="cs_modal_header cs_row align-items-center justify-content-between">
//               <div>
//                 <img src={logo} alt="Smash Code" />
//               </div>
//               <button onClick={() => setModal(false)} className="cs_icon_btn">
//                 &times;
//               </button>
//             </header>
//             <div className="cs_modal_body">
//               <h3>Edit Project :</h3>
//               <br />
//               <form onSubmit={handleUpdateData}>
//                 <div>
//                   <input
//                     type="text"
//                     id="name"
//                     name="name"
//                     onChange={handleChange}
//                     placeholder="Website Name"
//                     required
//                     value={inputValues.name}
//                   />
//                   <br /> <br />
//                   <textarea
//                     name="description"
//                     id="description"
//                     value={inputValues.description}
//                     onChange={handleChange}
//                     cols="30"
//                     rows="3"
//                     placeholder="Project Description"
//                   ></textarea>
//                   <br /> <br />
//                   <input
//                     type="url"
//                     name="link"
//                     id="link"
//                     onChange={handleChange}
//                     placeholder="Website Link"
//                     required
//                     value={inputValues.link}
//                   />
//                   <br /> <br />
//                   <input
//                     type="text"
//                     id="order_number"
//                     name="order_number"
//                     onChange={handleChange}
//                     placeholder="Order Number"
//                     value={inputValues.order_number}
//                   />
//                   <br />
//                   <br />
//                   <p>Category</p>
//                   <div className="checkList">
//                     <div className="ctCheckList cs_row align-items-center justify-content-between">
//                       <div className="ctData cs_row align-items-center flex-wrap">
//                         {projectCategorySelected.length > 0
//                           ? projectCategorySelected.map((val) => (
//                               <p key={val}>
//                                 {val}{' '}
//                                 <span
//                                   onClick={() => handleUnselectCategory(val)}
//                                 >
//                                   x
//                                 </span>
//                               </p>
//                             ))
//                           : null}
//                       </div>
//                       <button
//                         className="exIconBtn"
//                         onClick={handleShowCategoryList}
//                         type="button"
//                       >
//                         &#9660;
//                       </button>
//                     </div>
//                     {toggleCategoryList ? (
//                       <div className="ctList">
//                         {categoriesData?.length
//                           ? categoriesData.map((val) => {
//                               let isTrue = projectCategorySelected.includes(
//                                 val.category,
//                               )
//                               return (
//                                 <div
//                                   className="categories cs_row align-items-center "
//                                   key={val.id}
//                                 >
//                                   <input
//                                     type="checkbox"
//                                     name="category"
//                                     id={val.category}
//                                     checked={isTrue}
//                                     value={val.category}
//                                     onChange={handleSetCategory}
//                                   />
//                                   <p>{val.category}</p>
//                                 </div>
//                               )
//                             })
//                           : null}
//                       </div>
//                     ) : null}
//                   </div>
//                   <br />
//                   <select
//                     name="status"
//                     id="status"
//                     onChange={handleChange}
//                     value={inputValues.status}
//                   >
//                     <option value="">Status</option>
//                     <option value="Pending">Pending</option>
//                     <option value="Published">Published</option>
//                   </select>
//                   <br />
//                   <br />
//                   <select
//                     name="beckend"
//                     required
//                     id="beckend"
//                     onChange={handleChange}
//                     value={inputValues.beckend}
//                   >
//                     <option value="full stack">Beckend</option>
//                     <option value="true">true</option>
//                     <option value="false">false</option>
//                   </select>
//                   <br />
//                   <br />
//                   <select
//                     name="platform"
//                     required
//                     id="platform"
//                     onChange={handleChange}
//                     value={inputValues.platform}
//                   >
//                     <option value="full stack">Platform</option>
//                     <option value="Fiverr">Fiverr</option>
//                     <option value="Upwork">Upwork</option>
//                     <option value="others">others</option>
//                   </select>
//                   <br />
//                   <br />
//                   <select
//                     name="portfolio"
//                     id="portfolio"
//                     onChange={handleChange}
//                     value={inputValues.portfolio}
//                     required
//                   >
//                     <option value="">Portfolio</option>
//                     <option value="true">true</option>
//                     <option value="false">false</option>
//                   </select>
//                   <br />
//                   <br />
//                   <select
//                     name="footer_branding"
//                     id="footer_branding"
//                     onChange={handleChange}
//                     value={inputValues.footer_branding}
//                   >
//                     <option value="">Footer Branding</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                   <br />
//                   <br />
//                   <select
//                     name="url_branding"
//                     id="url_branding"
//                     onChange={handleChange}
//                     value={inputValues.url_branding}
//                   >
//                     <option value="">URL Branding</option>
//                     <option value="Yes">Yes</option>
//                     <option value="No">No</option>
//                   </select>
//                   <br />
//                   <br />
//                   <textarea
//                     name="notes"
//                     id="notes"
//                     value={inputValues.notes}
//                     onChange={handleChange}
//                     cols="30"
//                     rows="3"
//                     placeholder="Notes"
//                   ></textarea>
//                 </div>
//                 <footer className="cs_modal_footer cs_row align-items-center justify-content-between">
//                   <span></span>
//                   <button className="cs_btn" disabled={submitting}>
//                     Save &#10004;
//                   </button>
//                 </footer>
//               </form>
//             </div>
//           </div>
//         </div>
//       </Modal>

//       <div className="cs_row px-2 justify-content-between flex-wrap">
//         <h1 className="text_center">Platform</h1>
//         <div className="cs_row align-items-center">
//           <button
//             className="cs_btn cs_btn_outline"
//             onClick={handleDownloadJson}
//             disabled={exporting || !data?.length}
//             title="Download all projects, with every field, as a JSON file"
//           >
//             &#11015; {exporting ? 'Preparing...' : 'Download JSON'}
//           </button>
//         </div>
//       </div>

//       <div>
//         <br />
//         <div style={{ width: '30%' }} className="fList">
//           <h2> Filters </h2>
//           <p>Platform :</p>
//           <ul className="">
//             {platforms.length > 0
//               ? platforms.map((val) => (
//                   <li
//                     className="cs_row px-2 py-1  justify-content-between align-items-center"
//                     key={val}
//                   >
//                     <span>{val}</span>
//                     <input
//                       type="checkbox"
//                       value={val}
//                       onChange={handleChangeFilter}
//                     />
//                   </li>
//                 ))
//               : null}
//           </ul>
//           <p>Portfolio :</p>
//           <div>
//             <label
//               htmlFor="true"
//               className="cs_row px-2   justify-content-between align-items-center"
//             >
//               <p>True</p>
//               <input
//                 type="radio"
//                 name="portfolio"
//                 id="true"
//                 value="true"
//                 onChange={handleRadio}
//               />
//             </label>
//             <label
//               htmlFor="false"
//               className="cs_row px-2   justify-content-between align-items-center"
//             >
//               <p>False</p>
//               <input
//                 type="radio"
//                 name="portfolio"
//                 id="false"
//                 value="false"
//                 onChange={handleRadio}
//               />
//             </label>
//             <label
//               htmlFor="all"
//               className="cs_row px-2   justify-content-between align-items-center"
//             >
//               <p>All</p>
//               <input
//                 type="radio"
//                 name="portfolio"
//                 id="all"
//                 value=""
//                 onChange={handleRadio}
//               />
//             </label>
//           </div>
//           <p>Branding :</p>
//           <div>
//             <label
//               htmlFor="noFooterBranding"
//               className="cs_row px-2   justify-content-between align-items-center"
//             >
//               <p>No Footer Branding</p>
//               <input
//                 type="checkbox"
//                 name="noFooterBranding"
//                 id="noFooterBranding"
//                 checked={noFooterBranding}
//                 onChange={(e) => setNoFooterBranding(e.target.checked)}
//               />
//             </label>
//             <label
//               htmlFor="noUrlBranding"
//               className="cs_row px-2   justify-content-between align-items-center"
//             >
//               <p>No URL Branding</p>
//               <input
//                 type="checkbox"
//                 name="noUrlBranding"
//                 id="noUrlBranding"
//                 checked={noUrlBranding}
//                 onChange={(e) => setNoUrlBranding(e.target.checked)}
//               />
//             </label>
//           </div>
//         </div>
//         <br />
//         <div className="searchBar cs_row flex-wrap">
//           <div style={{ width: '50%' }}>
//             <input
//               type="text"
//               value={searchValue}
//               placeholder="Search by name or order number"
//               onChange={handleSearch}
//             />
//           </div>
//           <br />
//         </div>

//         <div>
//           <p className="numProj">
//             Number Of Projects : {filterProjectData.length}
//           </p>
//         </div>
//         <br />
//         <div className="tbSection">
//           {filterProjectData.length > 0 ? (
//             <table id="customers">
//               <thead>
//                 <tr>
//                   <th>S.no</th>
//                   <th>Link</th>
//                   <th>Name</th>
//                   <th>Category</th>
//                   <th>Description</th>
//                   <th>Platform</th>
//                   <th>Beckend</th>
//                   <th>Portfolio</th>
//                   <th>Status</th>
//                   <th>Order No</th>
//                   <th>Footer Branding</th>
//                   <th>URL Branding</th>
//                   <th>Notes</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filterProjectData.map((val, i) => (
//                   <tr key={i}>
//                     <td>{i + 1}</td>
//                     <td id="links">
//                       <a
//                         href={val.inputValues.link}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         {val.inputValues.link}
//                       </a>{' '}
//                     </td>
//                     <td>{highlightMatch(val.inputValues.name, searchValue)}</td>
//                     <td>
//                       {val.categories.map((res) => (
//                         <span key={res}>{' ' + res + ' '}</span>
//                       ))}
//                     </td>
//                     <td style={{ minWidth: '200px' }}>
//                       {val.inputValues?.description}
//                     </td>
//                     <td>
//                       {val.inputValues.platform
//                         ? val.inputValues.platform
//                         : null}
//                     </td>
//                     <td>{val.inputValues.beckend}</td>
//                     <td>{val.inputValues.portfolio}</td>
//                     <td>{val.inputValues?.status}</td>
//                     <td>
//                       {highlightMatch(val.inputValues.order_number, searchValue)}
//                     </td>
//                     <td>{val.inputValues?.footer_branding}</td>
//                     <td>{val?.inputValues?.link.includes("smashcode") ? "Yes":"No"}</td>
//                     <td>{val.inputValues?.notes}</td>
//                     <td className="cs_row align-items-center justify-content-center">
//                       <button
//                         onClick={() => handleEdit(val)}
//                         className="my-2"
//                       >
//                         &#9998;
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : (
//             <div className="emptyState">
//               {searchValue ? (
//                 <p>No projects found matching "{searchValue}".</p>
//               ) : (
//                 <p>No projects match the current filters.</p>
//               )}
//             </div>
//           )}
//         </div>
//       </div>
//       <Alert data={alert} setAlert={setAlert} />
//     </div>
//   )
// }

// export default Platform


import { useData } from 'context/DataContext'
import React, { useMemo, useState } from 'react'
import Modal from 'utils/Modal'
import logo from 'assets/images/logo.png'
import Alert from 'utils/Alert'
import { db, ref, update } from 'config/Firebase'
import { exportProjectsToJson } from 'utils/exportProjectsToJson'

const platforms = ['Fiverr', 'Upwork', 'Others']

let valuesObject = {
  name: '',
  link: '',
  order_number: '',
  beckend: '',
  portfolio: '',
  platform: '',
  description: '',
  status: '',
  footer_branding: '',
  notes: '',
}

// URL branding is derived from the link itself (does it contain
// "smashcode"?) rather than a manually-set field, so this helper is the
// single source of truth used by both the table and the filter.
const hasUrlBranding = (link) =>
  (link || '').toLowerCase().includes('smashcode') ? 'Yes' : 'No'

const Platform = () => {
  const [filterState, setFilterState] = useState([])
  const [portfolioCheck, setPortfolioCheck] = useState('')
  const [searchValue, setSearchValue] = useState('')
  const [noFooterBranding, setNoFooterBranding] = useState(false)
  const [noUrlBranding, setNoUrlBranding] = useState(false)
  const [exporting, setExporting] = useState(false)

  // edit modal state
  const [modal, setModal] = useState(false)
  const [inputValues, setInputValues] = useState(valuesObject)
  const [projectCategorySelected, setProjectCategorySelected] = useState([])
  const [toggleCategoryList, settoggleCategoryList] = useState(false)
  const [projectId, setProjectId] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [alert, setAlert] = useState({ open: false, msg: '', type: '' })

  const { data, categoriesData } = useData()

  const handleChangeFilter = (e) => {
    if (e.target.checked) {
      setFilterState([...filterState, e.target.value])
    } else {
      let filter = filterState.filter((val) => val !== e.target.value)
      setFilterState(filter)
    }
  }

  const handleRadio = (e) => {
    setPortfolioCheck(e.target.value)
  }
  // main search box - matches against project name AND order number,
  // so there's a single search field instead of two separate ones
  const handleSearch = (e) => {
    setSearchValue(e.target.value)
  }

  // Single source of truth for filtering: combines every active filter
  // (search, platform, portfolio, footer branding, url branding) with AND
  // logic, and uses optional chaining throughout so a record missing any
  // field never throws and silently breaks the list.
  const filterProjectData = useMemo(() => {
    const list = Array.isArray(data) ? data : []
    const search = searchValue.trim().toLowerCase()

    return list.filter((val) => {
      const iv = val?.inputValues || {}

      if (search) {
        const nameMatch = (iv.name || '').toLowerCase().includes(search)
        const orderNumberMatch = (iv.order_number || '')
          .toLowerCase()
          .includes(search)
        if (!nameMatch && !orderNumberMatch) return false
      }

      if (filterState.length > 0) {
        const platformMatch = filterState.some(
          (el) => (iv.platform || '').toLowerCase() === el.toLowerCase(),
        )
        if (!platformMatch) return false
      }

      if (portfolioCheck && iv.portfolio !== portfolioCheck) {
        return false
      }

      if (noFooterBranding && iv.footer_branding !== 'No') {
        return false
      }

      // Derived the same way the table displays it (from the link),
      // instead of a stale/unset `url_branding` field on the record.
      if (noUrlBranding && hasUrlBranding(iv.link) !== 'No') {
        return false
      }

      return true
    })
  }, [
    data,
    filterState,
    portfolioCheck,
    searchValue,
    noFooterBranding,
    noUrlBranding,
  ])

  // download every project as a JSON file, straight from the data already
  // loaded in context - no extra fetch, no external service.
  const handleDownloadJson = () => {
    setExporting(true)
    try {
      const filename = exportProjectsToJson(data, {
        filenamePrefix: 'projects',
      })
      setAlert({
        open: true,
        msg: `Downloaded ${filename}`,
        type: 'success',
      })
    } catch (err) {
      console.log(err)
      setAlert({
        open: true,
        msg: 'Something went wrong generating the JSON file!',
        type: 'error',
      })
    } finally {
      setExporting(false)
    }
  }

  // wraps the portion of `text` that matches the current search box value
  // in a <mark>, so a hit on name or order number is visible at a glance
  const highlightMatch = (text, query) => {
    const str = text == null ? '' : String(text)
    if (!query) return str
    const lowerStr = str.toLowerCase()
    const lowerQuery = query.toLowerCase()
    let start = 0
    let idx = lowerStr.indexOf(lowerQuery, start)
    if (idx === -1) return str
    const parts = []
    while (idx !== -1) {
      parts.push(str.slice(start, idx))
      parts.push(
        <mark key={idx} className="search-highlight">
          {str.slice(idx, idx + query.length)}
        </mark>,
      )
      start = idx + query.length
      idx = lowerStr.indexOf(lowerQuery, start)
    }
    parts.push(str.slice(start))
    return parts
  }

  const handleChange = (e) => {
    setInputValues({ ...inputValues, [e.target.name]: e.target.value })
  }

  const handleSetCategory = (e) => {
    if (e.target.checked) {
      setProjectCategorySelected([...projectCategorySelected, e.target.value])
    } else {
      let filter = projectCategorySelected.filter(
        (val) => val !== e.target.value,
      )
      setProjectCategorySelected(filter)
    }
  }

  const handleUnselectCategory = (e) => {
    let filterdSelectedCategory = projectCategorySelected.filter(
      (val) => val !== e,
    )
    setProjectCategorySelected(filterdSelectedCategory)
  }

  const handleShowCategoryList = () => {
    settoggleCategoryList(!toggleCategoryList)
  }

  // edit an existing row
  const handleEdit = (event) => {
    setModal(true)
    setProjectCategorySelected(event.categories)
    setInputValues(event.inputValues)
    setProjectId(event.id)
  }

  const handleUpdateData = (e) => {
    e.preventDefault()
    setSubmitting(true)
    if (projectCategorySelected.length > 0) {
      update(ref(db, `projects/${projectId}`), {
        inputValues,
        categories: projectCategorySelected,
      })
        .then(() => {
          setModal(false)
          setSubmitting(false)
          setInputValues(valuesObject)
          setProjectId('')
          setProjectCategorySelected([])
          setAlert({
            open: true,
            msg: 'Data Updated successfully.',
            type: 'success',
          })
        })
        .catch((err) => {
          console.log(err)
          setModal(false)
          setSubmitting(false)
          setAlert({
            open: true,
            msg: 'Something went wrong!',
            type: 'error',
          })
        })
    } else {
      setSubmitting(false)
      setAlert({
        open: true,
        msg: 'Please select atleast one category',
        type: 'error',
      })
    }
  }

  return (
    <div>
      {/*================ Edit Modal ===================*/}
      <Modal open={modal}>
        <div className="cs_modal_wrapper">
          <div
            className="cs_modal_backdrop"
            onClick={() => setModal(false)}
          ></div>
          <div className="cs_modal">
            <header className="cs_modal_header cs_row align-items-center justify-content-between">
              <div>
                <img src={logo} alt="Smash Code" />
              </div>
              <button onClick={() => setModal(false)} className="cs_icon_btn">
                &times;
              </button>
            </header>
            <div className="cs_modal_body">
              <h3>Edit Project :</h3>
              <br />
              <form onSubmit={handleUpdateData}>
                <div>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    onChange={handleChange}
                    placeholder="Website Name"
                    required
                    value={inputValues.name}
                  />
                  <br /> <br />
                  <textarea
                    name="description"
                    id="description"
                    value={inputValues.description}
                    onChange={handleChange}
                    cols="30"
                    rows="3"
                    placeholder="Project Description"
                  ></textarea>
                  <br /> <br />
                  <input
                    type="url"
                    name="link"
                    id="link"
                    onChange={handleChange}
                    placeholder="Website Link"
                    required
                    value={inputValues.link}
                  />
                  <br /> <br />
                  <input
                    type="text"
                    id="order_number"
                    name="order_number"
                    onChange={handleChange}
                    placeholder="Order Number"
                    value={inputValues.order_number}
                  />
                  <br />
                  <br />
                  <p>Category</p>
                  <div className="checkList">
                    <div className="ctCheckList cs_row align-items-center justify-content-between">
                      <div className="ctData cs_row align-items-center flex-wrap">
                        {projectCategorySelected.length > 0
                          ? projectCategorySelected.map((val) => (
                              <p key={val}>
                                {val}{' '}
                                <span
                                  onClick={() => handleUnselectCategory(val)}
                                >
                                  x
                                </span>
                              </p>
                            ))
                          : null}
                      </div>
                      <button
                        className="exIconBtn"
                        onClick={handleShowCategoryList}
                        type="button"
                      >
                        &#9660;
                      </button>
                    </div>
                    {toggleCategoryList ? (
                      <div className="ctList">
                        {categoriesData?.length
                          ? categoriesData.map((val) => {
                              let isTrue = projectCategorySelected.includes(
                                val.category,
                              )
                              return (
                                <div
                                  className="categories cs_row align-items-center "
                                  key={val.id}
                                >
                                  <input
                                    type="checkbox"
                                    name="category"
                                    id={val.category}
                                    checked={isTrue}
                                    value={val.category}
                                    onChange={handleSetCategory}
                                  />
                                  <p>{val.category}</p>
                                </div>
                              )
                            })
                          : null}
                      </div>
                    ) : null}
                  </div>
                  <br />
                  <select
                    name="status"
                    id="status"
                    onChange={handleChange}
                    value={inputValues.status}
                  >
                    <option value="">Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Published">Published</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="beckend"
                    required
                    id="beckend"
                    onChange={handleChange}
                    value={inputValues.beckend}
                  >
                    <option value="full stack">Beckend</option>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="platform"
                    required
                    id="platform"
                    onChange={handleChange}
                    value={inputValues.platform}
                  >
                    <option value="full stack">Platform</option>
                    <option value="Fiverr">Fiverr</option>
                    <option value="Upwork">Upwork</option>
                    <option value="others">others</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="portfolio"
                    id="portfolio"
                    onChange={handleChange}
                    value={inputValues.portfolio}
                    required
                  >
                    <option value="">Portfolio</option>
                    <option value="true">true</option>
                    <option value="false">false</option>
                  </select>
                  <br />
                  <br />
                  <select
                    name="footer_branding"
                    id="footer_branding"
                    onChange={handleChange}
                    value={inputValues.footer_branding}
                  >
                    <option value="">Footer Branding</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <br />
                  <br />
                  <textarea
                    name="notes"
                    id="notes"
                    value={inputValues.notes}
                    onChange={handleChange}
                    cols="30"
                    rows="3"
                    placeholder="Notes"
                  ></textarea>
                </div>
                <footer className="cs_modal_footer cs_row align-items-center justify-content-between">
                  <span></span>
                  <button className="cs_btn" disabled={submitting}>
                    Save &#10004;
                  </button>
                </footer>
              </form>
            </div>
          </div>
        </div>
      </Modal>

      <div className="cs_row px-2 justify-content-between flex-wrap">
        <h1 className="text_center">Platform</h1>
        <div className="cs_row align-items-center">
          <button
            className="cs_btn cs_btn_outline"
            onClick={handleDownloadJson}
            disabled={exporting || !data?.length}
            title="Download all projects, with every field, as a JSON file"
          >
            &#11015; {exporting ? 'Preparing...' : 'Download JSON'}
          </button>
        </div>
      </div>

      <div>
        <br />
        <div style={{ width: '30%' }} className="fList">
          <h2> Filters </h2>
          <p>Platform :</p>
          <ul className="">
            {platforms.length > 0
              ? platforms.map((val) => (
                  <li
                    className="cs_row px-2 py-1  justify-content-between align-items-center"
                    key={val}
                  >
                    <span>{val}</span>
                    <input
                      type="checkbox"
                      value={val}
                      onChange={handleChangeFilter}
                    />
                  </li>
                ))
              : null}
          </ul>
          <p>Portfolio :</p>
          <div>
            <label
              htmlFor="true"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>True</p>
              <input
                type="radio"
                name="portfolio"
                id="true"
                value="true"
                onChange={handleRadio}
              />
            </label>
            <label
              htmlFor="false"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>False</p>
              <input
                type="radio"
                name="portfolio"
                id="false"
                value="false"
                onChange={handleRadio}
              />
            </label>
            <label
              htmlFor="all"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>All</p>
              <input
                type="radio"
                name="portfolio"
                id="all"
                value=""
                onChange={handleRadio}
              />
            </label>
          </div>
          <p>Branding :</p>
          <div>
            <label
              htmlFor="noFooterBranding"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>No Footer Branding</p>
              <input
                type="checkbox"
                name="noFooterBranding"
                id="noFooterBranding"
                checked={noFooterBranding}
                onChange={(e) => setNoFooterBranding(e.target.checked)}
              />
            </label>
            <label
              htmlFor="noUrlBranding"
              className="cs_row px-2   justify-content-between align-items-center"
            >
              <p>No URL Branding</p>
              <input
                type="checkbox"
                name="noUrlBranding"
                id="noUrlBranding"
                checked={noUrlBranding}
                onChange={(e) => setNoUrlBranding(e.target.checked)}
              />
            </label>
          </div>
        </div>
        <br />
        <div className="searchBar cs_row flex-wrap">
          <div style={{ width: '50%' }}>
            <input
              type="text"
              value={searchValue}
              placeholder="Search by name or order number"
              onChange={handleSearch}
            />
          </div>
          <br />
        </div>

        <div>
          <p className="numProj">
            Number Of Projects : {filterProjectData.length}
          </p>
        </div>
        <br />
        <div className="tbSection">
          {filterProjectData.length > 0 ? (
            <table id="customers">
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>Link</th>
                  <th>Name</th>
                  <th>Category</th>
                  <th>Description</th>
                  <th>Platform</th>
                  <th>Beckend</th>
                  <th>Portfolio</th>
                  <th>Status</th>
                  <th>Order No</th>
                  <th>Footer Branding</th>
                  <th>URL Branding</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filterProjectData.map((val, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td id="links">
                      <a
                        href={val.inputValues.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {val.inputValues.link}
                      </a>{' '}
                    </td>
                    <td>{highlightMatch(val.inputValues.name, searchValue)}</td>
                    <td>
                      {val.categories.map((res) => (
                        <span key={res}>{' ' + res + ' '}</span>
                      ))}
                    </td>
                    <td style={{ minWidth: '200px' }}>
                      {val.inputValues?.description}
                    </td>
                    <td>
                      {val.inputValues.platform
                        ? val.inputValues.platform
                        : null}
                    </td>
                    <td>{val.inputValues.beckend}</td>
                    <td>{val.inputValues.portfolio}</td>
                    <td>{val.inputValues?.status}</td>
                    <td>
                      {highlightMatch(val.inputValues.order_number, searchValue)}
                    </td>
                    <td>{val.inputValues?.footer_branding}</td>
                    <td>{hasUrlBranding(val?.inputValues?.link)}</td>
                    <td>{val.inputValues?.notes}</td>
                    <td className="cs_row align-items-center justify-content-center">
                      <button
                        onClick={() => handleEdit(val)}
                        className="my-2"
                      >
                        &#9998;
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="emptyState">
              {searchValue ? (
                <p>No projects found matching "{searchValue}".</p>
              ) : (
                <p>No projects match the current filters.</p>
              )}
            </div>
          )}
        </div>
      </div>
      <Alert data={alert} setAlert={setAlert} />
    </div>
  )
}

export default Platform